import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Text, TextStyle } from "pixi.js";

export class WalletFullBuildingInfo extends Container {
    private address: Text;
    private additionalAddress: Text;

    public constructor() {
        super();
        this.build();
    }

    private build(): void {
        this.address = new Text("1799 LEXINGTON AVE", new AddressTextStyle());
        this.address.anchor.set(0.5);

        this.additionalAddress = new Text("10010, NYC, MANHATTAN", new AdditionalAddressTextStyle());
        this.additionalAddress.anchor.set(0.5);
        this.additionalAddress.position.y = this.address.y + this.address.height * 0.5 + this.additionalAddress.height * 0.5 + 10;

        this.addChild(this.address, this.additionalAddress);
    }

    public updateAddress(address: string, additionalAddress: string): void {
        this.address.text = address;
        this.additionalAddress.text = additionalAddress;
        this.additionalAddress.position.y = this.address.y + this.address.height * 0.5 + this.additionalAddress.height * 0.5 + 10;
    }
}

class AddressTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72
        }));
    }
}

class AdditionalAddressTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#b9b2cc",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 37.77
        }));
    }
}
